<template>
  <div class="items-center no-wrap text">
    {{ t('common.lastChange') }}
    <q-chip size="sm">
      <div class="ellipsis">
        {{ props.date }}
        <q-tooltip>
          {{ props.date }}
        </q-tooltip>
      </div>
    </q-chip>
    <q-chip size="sm">
      <div class="ellipsis">
        {{ props.editorName }}
        <q-tooltip>
          {{ props.editorName }}
        </q-tooltip>
      </div>
    </q-chip>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  date: string;
  editorName: string;
}>();

const { t } = useI18n();
</script>
<style scoped lang="scss">
@import 'styles/app.variables.scss';
</style>
